import { createFileRoute } from "@tanstack/react-router"
import { WhatsappOpeningMessages } from "modules/campaigns/components/Sections/channels/whatsappOpeningMessages"
import { PaginationSearchSchema } from "modules/shared/hooks/usePagination"
import { SearchQuerySchema } from "modules/shared/hooks/useSearchQuery"
import { WhatsappOpeningMessagesFilterBySchema, WhatsappOpeningMessagesSortSchema } from "schema"
import z from "zod"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = PaginationSearchSchema.merge(SearchQuerySchema)
  .merge(WhatsappOpeningMessagesSortSchema.shape.sortBy.unwrap())
  .merge(WhatsappOpeningMessagesFilterBySchema)

export const Route = createFileRoute("/_base/_auth/settings/channels/whatsapp/openings/")({
  component: WhatsappOpeningMessages,
  validateSearch: (search: Partial<z.input<typeof SearchSchema>>) => {
    search.filterBy = search.filterBy || {}
    return SearchSchema.parse(search)
  },
})
